import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './daterangepicker.css'

document.addEventListener("DOMContentLoaded", () => {
  const wpRootElements = document.querySelectorAll('.wp-block-osica-store-event-list');

  wpRootElements.forEach(element => {
    const storeId = parseInt(element.getAttribute('data-store-event-id') ?? '-1');
    if (storeId <= 0) {
      return;
    }

    const root = ReactDOM.createRoot(element);
    root.render(
      <React.StrictMode>
        <App id={storeId} />
      </React.StrictMode>
    );

  });
});